const switchEndpointBase = process.env.SWITCH_APP_API;
const REMOTE_URL = `${switchEndpointBase}/api/v1`;
const DEV_URL = "http://127.0.0.1:8000/api/v1";

export const BASE_API_URL =  (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? DEV_URL : REMOTE_URL;
